import { type WfmTask } from "../../../amplify/backend/function/Cap/ts/public/types";
import { type Cap, type CapDoc } from "../capTypes";

type CapPackageOpsState = "present" | "close" | "complete";

const CAP_PACKAGE_DOCUMENT_TYPE = "CAP Package";
const COMPLETE_CAP_PACKAGE_TASK_NAME = "COMPLETE CAP PACKAGE";

const getCapPackageDoc = (documents?: CapDoc[]): CapDoc | undefined =>
  documents?.find((d) => d.documentType === CAP_PACKAGE_DOCUMENT_TYPE);

const hasCapPackageDocs = (documents?: CapDoc[]): boolean =>
  !!getCapPackageDoc(documents);

const CUSTOMER_SIGNED_STATUS = "customer signed";

const isCustomerSignedStatus = (status?: string): boolean =>
  status?.trim().toLowerCase() === CUSTOMER_SIGNED_STATUS;

/** Uses getCapDocs CAP Package `customerSigned` (same source as Read & Sign). */
const isCapPackageCustomerSigned = (documents?: CapDoc[]): boolean => {
  const capPackageDoc = getCapPackageDoc(documents);
  return isCustomerSignedStatus(capPackageDoc?.customerSigned);
};

const getActiveSalesCapTask = (cap?: Cap) =>
  cap?.salesCapTasks?.find((task) => task.status !== "Inactive");

const hasOpenRequiredCapTask = (cap?: Cap): boolean =>
  !!getActiveSalesCapTask(cap);

const isCompleteCapPackageTaskComplete = (tasks?: WfmTask[]): boolean =>
  tasks?.[0]?.status === "Complete";

const getCapPackageOpsState = (args: {
  documents?: CapDoc[];
  cap?: Cap;
  completeCapPackageTasks?: WfmTask[];
}): CapPackageOpsState | null => {
  const { documents, cap, completeCapPackageTasks } = args;

  if (isCompleteCapPackageTaskComplete(completeCapPackageTasks)) {
    return "complete";
  }

  if (!hasOpenRequiredCapTask(cap)) {
    return null;
  }

  return hasCapPackageDocs(documents) ? "close" : "present";
};

export {
  CAP_PACKAGE_DOCUMENT_TYPE,
  COMPLETE_CAP_PACKAGE_TASK_NAME,
  getActiveSalesCapTask,
  getCapPackageDoc,
  getCapPackageOpsState,
  hasCapPackageDocs,
  hasOpenRequiredCapTask,
  isCapPackageCustomerSigned,
  isCompleteCapPackageTaskComplete,
};
export type { CapPackageOpsState };
